import { createContext } from "react";

const InvestmentContext = createContext(null);

export default InvestmentContext;